export class SidenavItem {
    title: string;
    icon: string;
    route: string;
    adminsOnly: boolean;
    // URL prefixes the item is highlighted for; defaults to its route
    paths: string[];

    constructor (title: string, icon: string, route: string, adminsOnly: boolean = false, paths?: string[]) {
        this.title = title;
        this.icon = icon;
        this.route = route;
        this.adminsOnly = adminsOnly;
        this.paths = paths ?? [route];
    }
}
